// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2_NWV","alert":"SettungsInbox_alert__1uwV-"};